"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536499/img/hero_tree_roots_background.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-background/40" aria-hidden="true" />

      {}
      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto px-6 py-16 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <h1 className="text-5xl md:text-6xl font-bold text-foreground mb-6 leading-tight">
          Home
        </h1>

        {}
        <p className="text-xl md:text-2xl text-foreground/90 mb-10 max-w-2xl mx-auto">
          Monitor project vitals, detect scope gaps, and optimize subcontractor
          performance with AMPKORE's intelligent platform.
        </p>

        {}
        <Link to="#contact-form">
          <Button size="lg" className="btn-primary text-lg px-8 py-6 h-auto hover-lift">
            Request a Demo
          </Button>
        </Link>
      </div>
    </section>;
}